import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGoogleDrive = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M16.406 4a1.009 1.009 0 0 0-.656.469l-15.594 25a.996.996 0 0 0-.062.968l7.812 16c.168.348.52.567.907.563h31.5c.367-.004.703-.207.874-.531l8.688-16a1.005 1.005 0 0 0-.031-1l-15.594-25A.993.993 0 0 0 33.406 4H16.406Zm.875 2h15.563L47.53 29.563 29.406 24Zm-.343.375 4.156 17.031L9.375 44.938 2.156 30.062Zm7.875 15.031L29.688 29h-9.375Zm23 8.657L39.719 45H9.938L25 31.5Z" />
    </svg>
);
export default SvgGoogleDrive;
